/**
 * Complete Follow-Up Modal Component
 */

import React from 'react';
import { Modal } from 'antd';

interface CompleteFollowUpModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  followUpName?: string;
}

export const CompleteFollowUpModal: React.FC<CompleteFollowUpModalProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
  followUpName,
}) => {
  return (
    <Modal
      title="Mark Follow-Up as Complete"
      open={open}
      onCancel={onClose}
      onOk={onConfirm}
      okText="Confirm"
      cancelText="Cancel"
      confirmLoading={isLoading}
      width={500}
    >
      <p className="text-gray-600 mb-2">
        Are you sure you want to mark this follow-up as complete?
      </p>
      {followUpName && (
        <p className="text-sm text-gray-700 mb-3">
          <strong>Follow-up:</strong> {followUpName}
        </p>
      )}
      <p className="text-sm text-gray-500">
        This action will close the follow-up and remove it from your active queue.
      </p>
    </Modal>
  );
};

export default CompleteFollowUpModal;
